import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: "app-reason",
  templateUrl: "./reason.component.html",
  styleUrls: ["./reason.component.scss"],
})
export class ReasonComponent implements OnInit {
  public title: string;
  public message: string;
  constructor(
    public dialogRef: MatDialogRef<ReasonComponent>,

    private fb: FormBuilder
  ) {}

  form: FormGroup = new FormGroup({
    reason: new FormControl(),
  });
  ngOnInit() {}

  onSubmit() {
    this.dialogRef.close(this.form.get("reason").value);
  }
}
